// extracted by mini-css-extract-plugin
export default {"calendarContainer":"BigCalendar_calendarContainer__tG1U7"};